<template>
    <svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M16 3a1 1 0 0 0-1.316-.949L5.838 5H2a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h.98l.84 4.196a1 1 0 1 0 1.96-.392L5.02 13h.818l8.846 2.948A1 1 0 0 0 16 15v-3.2a3 3 0 0 0 0-6V3ZM3.82 11H5V7H3v4H3.821Zm3.18.28V6.72l7-2.333v9.225L7 11.28Zm9-1.48a1 1 0 1 0 0-2v2Z" />
    </svg>
</template>
